module.exports = __webpack_public_path__ + "img/pics_almost-free.a5faa540.svg";